import { render } from "./WeddingSlider.vue?vue&type=template&id=22a49529&scoped=true&ts=true"
import script from "./WeddingSlider.vue?vue&type=script&lang=ts"
export * from "./WeddingSlider.vue?vue&type=script&lang=ts"

import "./WeddingSlider.vue?vue&type=style&index=0&id=22a49529&lang=scss&scoped=true"

import exportComponent from "/home/klaus/Dokumente/Projekte/Hochzeit/wedding-slideshow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a49529"]])

export default __exports__